module.exports = ".ui-multiselect-label-container\r\n{\r\n    color:black !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/reportdashboard/voluntaryrptmetadata/voluntaryrptmetadata.component.css
// module id = ./src/app/reportdashboard/voluntaryrptmetadata/voluntaryrptmetadata.component.css
// module chunks = main